import React from 'react';
import styled from 'styled-components';
import { MemberType, Squad } from 'api/models';
import { Avatar, AvatarGroup } from 'components/atoms/avatar';
import { CpBody00Secondary } from 'components/atoms/customer-portal/typography';
import { PlaceholderAvatar } from 'components/molecules/placeholder-avatar';
import { fullName } from 'utils/full-name';

const AssigneeLabel = styled(CpBody00Secondary)`
  margin-bottom: 0;
  margin-left: var(--cp-spacing-03);

  @media (max-width: 480px) {
    display: none;
  }
`;

export const CpTaskCardAssignees: React.FC<{ assignee: Squad | undefined }> = ({
  assignee,
}) => {
  if (!assignee) {
    return <></>;
  }

  if (!assignee?.users?.length && !assignee?.teams?.length) {
    return <></>;
  }

  type USerOrTeam =
    | {
        name: string;
        photoUrl?: string;
        type: 'user';
      }
    | {
        name: string;
        isCustomerRole: boolean;
        type: 'team';
      };

  const allAssignees: USerOrTeam[] = (assignee?.users ?? [])
    .map(
      (e) =>
        ({
          name: fullName(e),
          photoUrl: e?.photoUrl,
          type: 'user',
        } as USerOrTeam),
    )
    .concat(
      (assignee?.teams ?? []).map((e) => ({
        name: e?.teamName,
        isCustomerRole:
          // TODO: fix this
          e?.teamType === MemberType.External || e?.teamName === 'Customer',
        type: 'team',
      })),
    );

  if (allAssignees?.length > 1) {
    return (
      <div className="cp-flex cp-ml-[var(--cp-spacing-02)] cp-items-center cp-justify-center">
        <AvatarGroup>
          {allAssignees?.map((uOrT) => {
            if (uOrT.type === 'team') {
              return (
                <PlaceholderAvatar
                  isCustomerRole={uOrT?.isCustomerRole}
                  name={uOrT?.name}
                />
              );
            }

            return (
              <Avatar
                src={uOrT?.photoUrl}
                name={uOrT?.name}
                alt={uOrT?.name}
                size="small"
              />
            );
          })}
        </AvatarGroup>
      </div>
    );
  }

  const uOrT = allAssignees[0];

  return uOrT ? (
    <div className="cp-flex cp-ml-[var(--cp-spacing-02)] cp-items-center cp-justify-center">
      {uOrT.type === 'team' ? (
        <PlaceholderAvatar
          isCustomerRole={uOrT?.isCustomerRole}
          name={uOrT?.name}
        />
      ) : (
        <Avatar
          src={uOrT?.photoUrl}
          name={uOrT?.name}
          alt={uOrT?.name}
          size="small"
        />
      )}
      <AssigneeLabel>{uOrT?.name}</AssigneeLabel>
    </div>
  ) : (
    <></>
  );
};
